export default __webpack_public_path__ + "static/media/bfc-logo-gif.5bafc659.gif";